import {
  getTosId,
} from '@homeservices/api-kit/security/tos';

function initialState () {
  return {
    email: '',
    password: '',
    passwordConfirmation: '',
    firstName: '',
    lastName: '',
    phone: '',
    tosId: null,
    preferredContactMethod: 'PHONE',
    smsOptIn: false,
  };
}

export default {
  namespaced: true,
  state: initialState,
  getters: {
    email (state) {
      return state.email;
    },
    password (state) {
      return state.password;
    },
    passwordConfirmation (state) {
      return state.passwordConfirmation;
    },
    firstName (state) {
      return state.firstName;
    },
    lastName (state) {
      return state.lastName;
    },
    phone (state) {
      return state.phone;
    },
    tosId (state) {
      return state.tosId;
    },
    preferredContactMethod (state) {
      return state.preferredContactMethod;
    },
    smsOptIn (state) {
      return state.smsOptIn;
    },
  },
  actions: {
    async fetchTosId ({ commit }) {
      const { data: { id } } = await getTosId('consumer');
      commit('setTos', id);
    },
    setEmail ({ commit }, email) {
      commit('setEmail', email);
    },
    setPassword ({ commit }, password) {
      commit('setPassword', password);
    },
    setPasswordConfirmation ({ commit }, passwordConfirmation) {
      commit('setPasswordConfirmation', passwordConfirmation);
    },
    setFirstName ({ commit }, firstName) {
      commit('setFirstName', firstName);
    },
    setLastName ({ commit }, lastName) {
      commit('setLastName', lastName);
    },
    setPhone ({ commit }, phone) {
      commit('setPhone', phone);
    },
    setPreferredContactMethod ({ commit }, contactMethod) {
      commit('setPreferredContactMethod', contactMethod);
    },
    setSmsOptIn ({ commit }, value) {
      commit('setSmsOptIn', value);
    },
    clear ({ commit }) {
      commit('clear');
    },
  },
  mutations: {
    setEmail (state, email) {
      state.email = email;
    },
    setPassword (state, password) {
      state.password = password;
    },
    setPasswordConfirmation (state, passwordConfirmation) {
      state.passwordConfirmation = passwordConfirmation;
    },
    setFirstName (state, firstName) {
      state.firstName = firstName;
    },
    setLastName (state, lastName) {
      state.lastName = lastName;
    },
    setPhone (state, phone) {
      state.phone = phone.slice(-10);
    },
    setTos (state, id) {
      state.tosId = id;
    },
    setPreferredContactMethod (state, contactMethod) {
      state.preferredContactMethod = contactMethod;
    },
    setSmsOptIn (state, value) {
      state.smsOptIn = value;
    },
    clear (state) {
      Object.assign(state, initialState());
    },
  },
};
